import React from "react";
import "./WaitingForSelect.css";

const WaitingForSelect = ({ playerName }) => {
  return (
    <div className="selectionContainer">
      <p className="selectionWaiting">
        Waiting for {playerName} to choose a category and begin the round...
      </p>
    </div>
  );
};

export default WaitingForSelect;
